import { render } from "./AmountForm.vue?vue&type=template&id=0bd08237&scoped=true"
import script from "./AmountForm.vue?vue&type=script&lang=js"
export * from "./AmountForm.vue?vue&type=script&lang=js"

import "./AmountForm.vue?vue&type=style&index=0&id=0bd08237&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd08237"]])

export default __exports__